/*
  Reasons for shadow:
  - Redirect based on zip code from AOA in DSM
*/

import { navigate } from 'gatsby'
import zipLogic from '../../../../../utils/zipLogic'

const availabilitySubmit = async ({ values }) => {
  const redirectUrl = await zipLogic(values?.zip_postal)
  navigate(redirectUrl ?? 'https://www.hughesnetdeals.com/out-of-area')
}

export default availabilitySubmit
